// ─────────────────────────────────────────────
// custom.js — performance optimized
// ─────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {

  // Exit early if jQuery is unavailable
  if (typeof window.jQuery === 'undefined') return;

  const $ = window.jQuery;

  // ─────────────────────────────────────────
  // HERO SLIDER (Above the fold)
  // ─────────────────────────────────────────
  const heroSlider = $('.banner_slide-list');

  if (heroSlider.length && !heroSlider.hasClass('slick-initialized')) {
    heroSlider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false
    });
  }

  // ─────────────────────────────────────────
  // MARQUEE (Only if plugin exists)
  // ─────────────────────────────────────────
  if ($.fn.marquee) {

    const offerBar = $('.offer_icon_inner');

    if (offerBar.length) {
      offerBar.marquee({
        direction: 'left',
        duration: 12000,
        pauseOnHover: true,
        duplicated: true,
        startVisible: true
      });
    }

    const topBar = $('.top_bar_inner');

    if (topBar.length) {
      topBar.marquee({
        direction: 'left',
        duration: 12000,
        pauseOnHover: true,
        duplicated: true,
        startVisible: true
      });
    }
  }

  // ─────────────────────────────────────────
  // LAZY SLICK INITIALIZER
  // ─────────────────────────────────────────
  function lazyInitSlider(selector, settings) {

    const element = document.querySelector(selector);

    if (!element) return;

    const observer = new IntersectionObserver((entries, obs) => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        const $el = $(element);

        if (!$el.hasClass('slick-initialized')) {
          $el.slick(settings);
        }

        obs.unobserve(element);

      });

    }, {
      rootMargin: '300px'
    });

    observer.observe(element);
  }

  // ─────────────────────────────────────────
  // REVIEW SLIDER
  // ─────────────────────────────────────────
  lazyInitSlider('.reviewBox', {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });

  // ─────────────────────────────────────────
  // FEATURED COLLECTION SLIDER
  // ─────────────────────────────────────────
  lazyInitSlider('.featured_coll-sc .product-grid', {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // ─────────────────────────────────────────
  // PRODUCT REVIEW ACCORDION
  // ─────────────────────────────────────────
  const ratingCount = document.querySelector(
    '.product__info-container .review_rating'
  );

  if (ratingCount) {

    ratingCount.addEventListener('click', function (e) {

      e.preventDefault();

      const ratingSection = document.querySelector(
        '.product__accordion.review_pro'
      );

      if (!ratingSection) return;

      const ratingTrigger = ratingSection.querySelector(
        'button, .accordion__header, .accordion__title'
      );

      if (ratingTrigger) {
        ratingTrigger.click();

        requestAnimationFrame(() => {
          ratingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }

    });

  }

  // ─────────────────────────────────────────
  // PRODUCTS PER PAGE
  // ─────────────────────────────────────────
  const wrapper = document.querySelector('.products-per-page-wrapper');

  if (!wrapper) return;

  const select = wrapper.querySelector('#products-per-page');

  if (!select) return;

  select.addEventListener('change', function () {

    const limit = this.value;

    const url = new URL(window.location.href);

    url.searchParams.set('limit', limit);
    url.searchParams.set('page', '1');

    window.location.href = url.toString();

  });

});